import { render } from "./PendingMonetizeButton.vue?vue&type=template&id=06bfe410"
import script from "./PendingMonetizeButton.vue?vue&type=script&lang=js"
export * from "./PendingMonetizeButton.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__